
import EarthIcon from '@/components/finagent/icons/EarthIcon';
import SnippetIcon from '@/components/finagent/icons/SnippetIcon';

export default {
    name: "FinAgentLibrarySwitch",

    components: {
        EarthIcon,
        SnippetIcon,
    },


    computed: {
        isFinAgentLibrary() {
            return this.$isFinAgentLibraryPage(this.$route)
        },
    },
}
